export const VALE_USERS_EMAIL = [
  'valesolos@manejebem.com'
];